import type { User } from '../userTypes';

interface PasswordLinkAccessInput {
  /** Connected user's role. */
  callerRole: string | null;
  /** Connected user's username — used to detect one's own account. */
  callerUsername: string | null;
  /** Caller holds `users.modify` (the fiche is not read-only). */
  canModify: boolean;
  target: Pick<User, 'username'>;
}

/**
 * Single rule for offering the password-link action (HOMCO-1393), shared by the
 * list row menu and the fiche's block C. Mirrors POST /users/:id/password-link:
 * `@Roles('admin')` + `users.modify`, one's own account refused (403).
 *
 * The target's active status is deliberately left to each screen: the row menu
 * hides the action for an inactive account, the fiche shows it disabled with a
 * « reactivate first » tooltip.
 */
export function canSendPasswordLink({
  callerRole,
  callerUsername,
  canModify,
  target,
}: PasswordLinkAccessInput): boolean {
  const isSelf = Boolean(callerUsername) && target.username === callerUsername;
  return canModify && callerRole === 'admin' && !isSelf;
}
